import { getSocialProofTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";

const SOCIAL_PROOF_EVENT_TYPES = {
  REQUEST_DATA: "requestData",
  UPDATE_SOCIAL_PROOF_DATA: "updateSocialProofData",
  VALIDATION: "validation",
  NEED_VALIDATION: "needValidation",
  SEND_DATA: "sendData",
};

const decodeFromSocialProofData = element => {
  if (!element) return {};

  return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
};

const editSocialProofConfig = (editor, shortcodeWrapper) => {
  let currentData = decodeFromSocialProofData(shortcodeWrapper.getAttribute("data-social-proof-data"));

  let isValid = null;

  const socialProofWindow = editor.windowManager.openUrl({
    title: "Social Proof",
    url: "/social-proof-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        socialProofWindow.sendMessage({
          type: SOCIAL_PROOF_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute(
        "data-social-proof-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === SOCIAL_PROOF_EVENT_TYPES.REQUEST_DATA) {
        sendData();
      }

      if (message.mceAction === SOCIAL_PROOF_EVENT_TYPES.SEND_DATA) {
        const { data } = message.data;
        if (data === "undefined") {
          // Handle case where user exits without saving
          currentData = null;
        } else {
          currentData = data;
          isValid = true;
        }
      }

      if (message.mceAction === SOCIAL_PROOF_EVENT_TYPES.UPDATE_SOCIAL_PROOF_DATA && message.data) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === SOCIAL_PROOF_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 700,
  });

  const sendData = () => {
    let existData = decodeFromSocialProofData(shortcodeWrapper.getAttribute("data-social-proof-data"));
    socialProofWindow.sendMessage({
      type: SOCIAL_PROOF_EVENT_TYPES.SEND_DATA,
      data: existData,
    });
  };
};

const socialProofConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const socialProofWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Social Proof",
    url: "/social-proof-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        socialProofWindow.sendMessage({
          type: SOCIAL_PROOF_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, getSocialProofTemplate(), "social-proof");

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(
        "data-social-proof-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === SOCIAL_PROOF_EVENT_TYPES.SEND_DATA) {
        const { data } = message.data;
        if (data === "undefined") {
          currentData = null;
        } else {
          currentData = data;
          isValid = true;
        }
      }

      if (message.mceAction === SOCIAL_PROOF_EVENT_TYPES.UPDATE_SOCIAL_PROOF_DATA) {
        currentData = message.data;
        isValid = true;

        return;
      }

      if (message.mceAction === SOCIAL_PROOF_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 700,
  });
};

export { socialProofConfig, editSocialProofConfig, SOCIAL_PROOF_EVENT_TYPES };
